export default __webpack_public_path__ + "static/media/b1.6d4e0486.jpg";